import React from "react";
import LightGallery from "lightgallery/react";

import { useTranslation } from 'react-i18next';

// Importamos los estilos y plugins de LightGallery
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-thumbnail.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-fullscreen.css";

/**
 * Componente ImageGallery para mostrar una galería de imágenes interactiva con LightGallery.
 * - Se filtran imágenes sin URL para evitar errores.
 * - Las imágenes se organizan en un diseño de 3 columnas con espacio entre ellas.
 * - Se activa la opción de miniaturas para navegar en la vista ampliada.
 */
const ImageGallery = ({ images }) => {
    const { t } = useTranslation();

    // Si no hay imágenes, no renderizamos la galería
    if (!images || images.length === 0) {
        return null;
    }

    console.log("Imágenes recibidas en ImageGallery:", images);

    return (
        <div style={{ textAlign: "center", padding: "20px" }}>
            <p>{t("Click on any image to open the preview")}</p>
            {/* Configuramos LightGallery con miniaturas y otras opciones */}
            <LightGallery speed={500} selector="a" thumbnail={true}>
                <div style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(3, 1fr)", // Organiza en 3 columnas
                    gap: "10px", // Espacio entre imágenes
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    {images
                        .filter(image => image.url) // Filtramos imágenes sin URL
                        .map((image, index) => (
                            <a
                                key={image.uuid || index}
                                href={image.url}
                                data-src={image.url}
                                data-sub-html={image.name || `Imagen ${index}`}
                            >
                                <img
                                    src={image.url}
                                    data-responsive={image.url}
                                    alt={`img-${image.name || index}`}
                                    height="200"
                                    style={{ width: "100%", objectFit: "cover", borderRadius: "5px" }}
                                />
                            </a>
                        ))
                    }
                </div>
            </LightGallery>
        </div>
    );
};

export default ImageGallery;
